import React, {Component} from "react";
import {
    Alert,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grow,
    Snackbar,
} from "@mui/material";
import User from "../backend/User";
import Backend from "../backend/Backend";
import {decodeToken} from "react-jwt";
import {Navigate} from "react-router-dom";
import Config from "../utils/Config";


class LoginPage extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            snackbarOpen: false,
            snackbarText: "",
            navigateToRoute: null,
        };
    }

    componentDidMount() {
        this.activate();
    }

    closeSnackbar = (event) => {
        this.setState({snackbarOpen: false});
    };

    redirect = () => {
        Backend.getData('/api/TAB_USERSETTINGS?US_Benutzername=' + User.getUsername() + '&US_Key=Startseite').then((startseite) => {
            let route = '';
            if (startseite.length === 0) {
                route = User.getHomepage();
            } else {
                route = '/' + startseite[0].US_Value;
            }
            this.setState({navigateToRoute: route});
        });
    }


    activate = () => {
        // Check for token from EntraID callback redirect
        const urlParams = new URLSearchParams(window.location.search);
        const tokenParam = urlParams.get('token');
        if (tokenParam) {
            // Remove token from URL
            window.history.replaceState({}, document.title, window.location.pathname);
            User.saveToken(tokenParam);
            User.decodeToken(tokenParam);
            const payload = decodeToken(tokenParam);
            // Kontoverbund vor allen Tenant-Checks: ein Hub-User hat in der Regel
            // selbst keinen Tenant und landete sonst auf /no-tenant.
            if (payload && payload.mustSelectAccount) {
                this.setState({navigateToRoute: '/select-account'});
                return;
            }
            if (payload && payload.isAdmin && (!payload.role || !payload.tenant)) {
                this.setState({navigateToRoute: '/admin-select'});
                return;
            }
            if (!payload || !payload.tenant) {
                this.setState({navigateToRoute: '/no-tenant'});
                return;
            }
            if (!payload.role) {
                this.setState({navigateToRoute: '/no-role'});
                return;
            }
            this.redirect();
            return;
        }

        const errorParam = urlParams.get('error');
        if (errorParam) {
            window.history.replaceState({}, document.title, window.location.pathname);
            let errorText;
            if (errorParam === 'tenant_locked') {
                errorText = 'Ihr Tenant ist aktuell gesperrt. Bitte wenden Sie sich an Ihren Administrator.';
            } else if (errorParam === 'maintenance') {
                errorText = 'Das System befindet sich aktuell im Wartungsmodus. Eine Anmeldung ist derzeit nur für Administratoren möglich.';
            } else {
                errorText = 'Microsoft-Anmeldung fehlgeschlagen!';
            }
            this.setState({snackbarOpen: true, snackbarText: errorText});
            return;
        }

        var token = User.getToken();
        if (token) {
            var params = decodeToken(token);
            if(params) {
                if (Math.round(new Date().getTime() / 1000) <= params.exp) {
                    if (params.mustSelectAccount) {
                        this.setState({navigateToRoute: '/select-account'});
                        return;
                    }
                    if (params.isAdmin && (!params.role || !params.tenant)) {
                        this.setState({navigateToRoute: '/admin-select'});
                        return;
                    }
                    if (!params.tenant) {
                        this.setState({navigateToRoute: '/no-tenant'});
                        return;
                    }
                    if (!params.role) {
                        this.setState({navigateToRoute: '/no-role'});
                        return;
                    }
                    this.redirect();
                }
            }
        }
    };

    loginWithMicrosoft = () => {
        window.location.href = Config.baseURL + '/api/v2/auth/entraid/login';
    };

    render() {
        if(this.state.navigateToRoute) {
            return <Navigate to={this.state.navigateToRoute} replace/>
        }
        return (
            <div>
                <div style={{
                    position: 'absolute', left: '50%', top: '50%',
                    transform: 'translate(-50%, -50%)'
                }}>

                    <Card sx={{maxWidth: 600}}>
                        <CardHeader title={"WebTrain"} style={{backgroundColor: "rgb(0,150,136)", color: 'white'}}/>
                        <CardContent>
                            <CardActions>
                                <Button type={"button"} onClick={this.loginWithMicrosoft} variant="contained"
                                        fullWidth color={"primary"}>
                                    Mit EntraID anmelden
                                </Button>
                            </CardActions>
                        </CardContent>
                    </Card>
                </div>
                <Snackbar open={this.state.snackbarOpen} autoHideDuration={5000} onClose={this.closeSnackbar}
                          anchorOrigin={{vertical: "top", horizontal: "right"}} TransitionComponent={Grow}>
                    <Alert onClose={this.closeSnackbar} severity={"error"} sx={{width: '100%'}}>
                        {this.state.snackbarText}
                    </Alert>
                </Snackbar>
            </div>
        )
    }
}
export default LoginPage;
